import styles from "../styles/layout.module.scss";
import Footer from "./footer";
import Navbar from "./navbar";
import Logo from "./logo";
const Layout = ({
  footer,
  navbar,
  logo,
  children,
  className,
  containerClassName,
  user,
}) => {
  return (
    <div className={className}>
      {navbar && <Navbar user={user} />}
      {logo && <Logo />}
      <div className={`${styles.mainContainer} ${containerClassName}`}>
        {children}
      </div>
      {footer && <Footer />}
    </div>
  );
};

export default Layout;
